export default __webpack_public_path__ + "static/media/kids-1.9ba01e93.jpeg";